import React from 'react';

import { GTMTracking } from '@common/ui/general';
import { toast } from '@common/ui/general/Toast';

import ACSConnectSuccess from '@alumni_v2/ui/SidebarModal/ACSConnectSuccess';
import TodosBeforeSession from '@alumni_v2/ui/SidebarModal/TodosBeforeSession';

import StarFilledIcon from '@alumni_v2/images/svg/star-filled.svg';

import styles from './CRTContent.module.scss';

const listItems = [
  [
    'Know your career options',
    'Personalised Roadmap',
  ],
  [
    'Curated by industry experts',
    'Instant insights',
  ],
];


const ListComp = () => listItems.map((listItem, index) => (
  <div key={index} className={styles.list}>
    {listItem.map(item => (
      <div key={item} className={styles.item}>
        <img src={StarFilledIcon} alt="star filled" />
        <div>{item}</div>
      </div>
    ))}
  </div>
));

const onCRTClick = (onModalClose) => {
  toast.show({
    message: 'Redirecting...',
    type: 'success',
    duration: 5000,
  });

  window.open('/career-plan', '_blank');
  onModalClose();
};

const CRTButton = ({ onModalClose }) => (
  <GTMTracking
    component="button"
    gtmEventType="cta"
    gtmEventAction="click"
    gtmEventResult="acs_crt_modal_button_clicked"
    gtmEventCategory="alumni_directory"
    className={styles.button}
    onClick={() => onCRTClick(onModalClose)}
    tabIndex={-1}
    role="button"
    gtmEventData={{
      click_type: 'acs_crt_modal_button_clicked',
      click_text: 'Generate My Career Roadmap',
      click_section: 'card_details',
    }}
  >
    Generate My Career Roadmap
  </GTMTracking>
);

const CRTContent = ({ onModalClose }) => (
  <>
    <ACSConnectSuccess context="intermediate_stage" />
    <TodosBeforeSession
      heading="Discover Your Path To a successful tech career"
      description="Answer 3 simple questions and get insights
      personalised to your journey"
      listComp={<ListComp />}
    />
    <CRTButton onModalClose={onModalClose} />
  </>
);

export default CRTContent;
